import { render, staticRenderFns } from "./baogaoDetail.vue?vue&type=template&id=07417b63&scoped=true"
import script from "./baogaoDetail.vue?vue&type=script&lang=js"
export * from "./baogaoDetail.vue?vue&type=script&lang=js"
import style0 from "./baogaoDetail.vue?vue&type=style&index=0&id=07417b63&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07417b63",
  null
  
)

export default component.exports